import { Snackbar } from 'src/app/shared/types/snackbar';

export const snackbarObjectFailedPayment: Snackbar = {
  duration: 2000,
  message: 'payments.snackbar_failed',
  horizontalPosition: 'center',
  verticalPosition: 'top',
  type: 'error-snackbar',
};
